var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"t",rawName:"v-t",value:('Locīšana'),expression:"'Locīšana'"}],staticClass:"h2"}),_c('ParamsMenu',{attrs:{"structure":_vm.structure},on:{"confirm":_vm.onConfirm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }